import { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

// Import de Context
import { useDataContext } from "../Context/dataContext";

// Import de Hooks
import { useAxiosInterceptors } from "../Hooks/useAxiosInterceptors";
import { useFetchData } from "../Hooks/useFetchData";

// Import de Navbar
import { UserNavbar } from "../Components/UserNavbar";

import { banksByCountry } from "../Utils/Variables";

// Import de Iconos
import {
  FaSearch,
  FaPlus,
  FaPaperPlane,
  FaEllipsisV,
  FaUser,
  FaTimes,
  FaUserFriends,
} from "react-icons/fa";

// Import de Reactstrap
import { Input } from "reactstrap";

function Directory() {
  // Context and hooks
  useAxiosInterceptors();
  const { url, accessToken } = useDataContext();
  const history = useHistory();

  //User data
  const { user, directory, loading } = useFetchData(accessToken.access_token);

  // Formulario para agregar contacto
  const [accbsUser_bank, setAccbsUser_bank] = useState("");
  const [accbsUser_owner, setAccbsUser_owner] = useState("");
  const [accbsUser_number, setAccbsUser_number] = useState("");
  const [accbsUser_dni, setAccbsUser_dni] = useState("");
  const [accbsUser_phone, setAccbsUser_phone] = useState("");
  const [accbsUser_country, setAccbsUser_country] = useState("");
  const [phonePrefix, setPhonePrefix] = useState("0414");
  const [dniPrefix, setDniPrefix] = useState("");
  const [transferType, setTransferType] = useState("");
  const [accountType, setAccountType] = useState("");

  // Buscador de contactos
  const [query, setQuery] = useState("");

  // Modal y estado de edición
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    setShowModal(false);
    setAccbsUser_bank("");
    setAccbsUser_owner("");
    setAccbsUser_number("");
    setAccbsUser_dni("");
    setAccbsUser_phone("");
    setAccbsUser_country("");
    setTransferType("");
  };

  // Estado para manejar la edición y eliminación de contactos
  const [openMenu, setOpenMenu] = useState(null);
  const [editingContact, setEditingContact] = useState(null);
  const [deleteContact, setDeleteContact] = useState(null);

  // Estado para manejar la carga y el estado de la operación
  const [operationStatus, setOperationStatus] = useState(null);

  const countries = [
    "Venezuela",
    "Colombia",
    "Chile",
    "Argentina",
    "Panama",
    "Brasil",
    "Ecuador",
    "Dominicana",
    "Estados Unidos",
    "Europa"
  ];

  // Manejo de cambios en el tipo de transferencia
  const handleTransferTypeChange = (e) => {
    const value = e.target.value;
    setTransferType(value);
    // Si selecciona "Cuenta Bancaria", limpia el teléfono
    if (value === "Cuenta Bancaria") {
      setPhonePrefix("0414");
      setAccbsUser_phone("");
    }
    // Si selecciona "Pago Móvil", limpia el número de cuenta
    if (value === "Pago Móvil") {
      setAccbsUser_number("");
    }
  };

  // Función para guardar el contacto
  const handleSaveAcc = async (event) => {
    event.preventDefault();
    // Mostrar el spinner
    setOperationStatus("loading");

    const finalPhone =
      transferType === "Pago Móvil"
        ? phonePrefix + accbsUser_phone
        : accbsUser_phone;

    try {
      await axios.post(
        `${url}/AccBsUser/create`,
        {
          accbsUser_bank: transferType === "Zelle" ? "Zelle" : accbsUser_bank,
          accbsUser_owner,
          accbsUser_number,
          accbsUser_dni:
            transferType === "Zelle" ? "Zelle" : dniPrefix + accbsUser_dni,
          accbsUser_phone: finalPhone,
          accbsUser_type: transferType,
          accbsUser_status: "Activo",
          accbsUser_userId: user.use_id,
          accbsUser_country,
          accbsUser_accountType: accountType ? accountType : "",
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      setOperationStatus("success");
      window.location.reload();
    } catch (error) {
      setOperationStatus("error");
    }
  };

  // Función para editar un contacto
  const handleEdit = async () => {
    setOperationStatus("loading");

    try {
      await axios.put(
        `${url}/AccBsUser/${editingContact.accbsUser_id}`,
        {
          accbsUser_owner: accbsUser_owner
            ? accbsUser_owner
            : editingContact.accbsUser_owner,

          accbsUser_bank: accbsUser_bank
            ? accbsUser_bank
            : editingContact.accbsUser_bank,

          accbsUser_number: accbsUser_number
            ? accbsUser_number
            : editingContact.accbsUser_number,

          accbsUser_dni:
            accbsUser_country === "Venezuela"
              ? dniPrefix + accbsUser_dni
                ? dniPrefix + accbsUser_dni
                : editingContact.accbsUser_dni
              : accbsUser_dni
              ? accbsUser_dni
              : editingContact.accbsUser_dni,

          accbsUser_phone: accbsUser_phone
            ? accbsUser_phone
            : editingContact.accbsUser_phone,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );

      setOperationStatus("success");
      window.location.reload();
    } catch (error) {
      setOperationStatus("error");
    }
  };

  // Función para deshabilitar un contacto
  const handleDelete = async () => {
    setOperationStatus("loading");
    try {
      await axios.put(
        `${url}/AccBsUser/${deleteContact}`,
        {
          accbsUser_status: "Inactivo",
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken.access_token}`,
          },
        }
      );
      setOperationStatus("success");
      window.location.reload();
    } catch (error) {
      setOperationStatus("error");
    }
  };

  const countryCodes = {
    Venezuela: "ve",
    Colombia: "co",
    Chile: "cl",
    Argentina: "ar",
    Panama: "pa",
    Brasil: "br",
    Ecuador: "ec",
    Dominicana: "do",
    "Estados Unidos": "us",
    Europa: "eu",
  };

  const filteredContacts = directory.filter(
    (c) =>
      c.accbsUser_status === "Activo" &&
      c.accbsUser_owner.toLowerCase().includes(query.toLowerCase())
  );

  return (
    <div className="directory-page">
      <div className="directory-header">
        <div className="header-text">
          <h2>
            <FaUserFriends /> Directorio
          </h2>
          <p>Administra tus contactos de manera rápida.</p>
        </div>
        <button className="add-contact-btn" onClick={() => setShowModal(true)}>
          <FaPlus /> Añadir contacto
        </button>
      </div>

      <div className="search-bar">
        <FaSearch />
        <input
          type="text"
          placeholder="Buscar contacto..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>

      {loading ? (
        <p className="contacts-grid">
          <span
            className="skeleton-loader"
            style={{ width: "100%", height: "200px" }}
          />
          <span
            className="skeleton-loader"
            style={{ width: "100%", height: "200px" }}
          />
        </p>
      ) : filteredContacts.length === 0 ? (
        <div className="no-results">
          <FaUserFriends className="no-results-icon" />
          <h4>Sin resultados</h4>
          <p>No se encontraron contactos que coincidan con tu búsqueda.</p>
        </div>
      ) : (
        <div className="contacts-grid">
          {filteredContacts.map((contact) => (
            <div className="contact-card" key={contact.accbsUser_id}>
              <div className="card-header">
                <div className="avatar">
                  <FaUser />
                  {countryCodes[contact.accbsUser_country] && (
                    <img
                      className="flag-badge"
                      src={`https://flagcdn.com/w20/${
                        countryCodes[contact.accbsUser_country]
                      }.png`}
                      srcSet={`https://flagcdn.com/w40/${
                        countryCodes[contact.accbsUser_country]
                      }.png 2x`}
                      width="20"
                      height="15"
                      alt={contact.accbsUser_country}
                    />
                  )}
                </div>
                <div className="card-menu">
                  <button
                    className="more-btn"
                    onClick={() =>
                      setOpenMenu(
                        openMenu === contact.accbsUser_id
                          ? null
                          : contact.accbsUser_id
                      )
                    }
                  >
                    <FaEllipsisV />
                  </button>
                  {openMenu === contact.accbsUser_id && (
                    <div className="options-menu visible">
                      <button
                        onClick={() => {
                          setEditingContact(contact);
                          setOpenMenu(null);
                        }}
                      >
                        Editar
                      </button>
                      <button
                        onClick={() => {
                          setDeleteContact(contact.accbsUser_id);
                          setOpenMenu(null);
                        }}
                      >
                        Deshabilitar
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="card-content">
                <h4>{contact.accbsUser_owner}</h4>
                <ul>
                  <li>
                    <strong>ID:</strong> {contact.accbsUser_dni}
                  </li>
                  {contact.accbsUser_number ? (
                    <li>
                      <strong>Cuenta:</strong> {contact.accbsUser_number}
                    </li>
                  ) : contact.accbsUser_phone ? (
                    <li>
                      <strong>Teléfono:</strong> {contact.accbsUser_phone}
                    </li>
                  ) : null}
                  <li>
                    <strong>Banco:</strong> {contact.accbsUser_bank || "N/A"}
                  </li>
                  <li>
                    <strong>Tipo:</strong> {contact.accbsUser_type}
                  </li>
                </ul>
              </div>

              <div className="card-footer">
                <button
                  className="send-btn"
                  onClick={() => history.push(`/SendMoney`)}
                >
                  <FaPaperPlane /> Enviar dinero
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal para editar contacto */}
      {editingContact && (
        <div className="modal-overlay">
          <div className="modal-content add-contact-modal">
            <button
              className="close-btn"
              onClick={() => setEditingContact(null)}
            >
              <FaTimes />
            </button>
            <h3>Editar contacto</h3>

            <form>
              <div className="form-group">
                <label>Nombre y Apellido *</label>
                <input
                  type="text"
                  defaultValue={editingContact.accbsUser_owner}
                  onChange={(e) =>
                    setEditingContact((prev) => ({
                      ...prev,
                      accbsUser_owner: e.target.value,
                    }))
                  }
                />
              </div>

              <div className="form-group">
                <label>Identificación *</label>
                <input
                  type="text"
                  defaultValue={editingContact.accbsUser_dni}
                  onChange={(e) =>
                    setEditingContact((prev) => ({
                      ...prev,
                      accbsUser_dni: e.target.value,
                    }))
                  }
                />
              </div>

              {editingContact.accbsUser_type === "Cuenta Bancaria" && (
                <div className="form-group">
                  <label>Número de Cuenta *</label>
                  <input
                    type="text"
                    defaultValue={editingContact.accbsUser_number || ""}
                    maxLength={
                      editingContact.accbsUser_country === "Venezuela"
                        ? 20
                        : undefined
                    }
                    pattern={
                      editingContact.accbsUser_country === "Venezuela"
                        ? "\\d{20}"
                        : undefined
                    }
                    inputMode={
                      editingContact.accbsUser_country === "Venezuela"
                        ? "numeric"
                        : "text"
                    }
                    onChange={(e) => {
                      let value = e.target.value;
                      if (editingContact.accbsUser_country === "Venezuela") {
                        // Solo números, sin espacios ni letras
                        value = value.replace(/\D/g, "");
                        if (value.length > 20) value = value.slice(0, 20);
                      }
                      setEditingContact((prev) => ({
                        ...prev,
                        accbsUser_number: value,
                      }));
                    }}
                  />
                  {editingContact.accbsUser_country === "Venezuela" &&
                    editingContact.accbsUser_number &&
                    editingContact.accbsUser_number.length > 0 &&
                    editingContact.accbsUser_number.length !== 20 && (
                      <span style={{ color: "red", fontSize: "0.9em" }}>
                        El número de cuenta debe tener exactamente 20 dígitos.
                      </span>
                    )}
                </div>
              )}

              <div className="form-group">
                <label>Banco *</label>
                <Input
                  type="select"
                  defaultValue={editingContact.accbsUser_bank || ""}
                  onChange={(e) =>
                    setEditingContact((prev) => ({
                      ...prev,
                      accbsUser_bank: e.target.value,
                    }))
                  }
                >
                  <option value="">Seleccione un banco</option>
                  {banksByCountry[editingContact.accbsUser_country]?.map(
                    (bank) => (
                      <option key={bank} value={bank}>
                        {bank}
                      </option>
                    )
                  )}
                </Input>
              </div>

              {editingContact.accbsUser_type === "Pago Móvil" && (
                <div className="form-group">
                  <label>Teléfono *</label>
                  <input
                    type="text"
                    maxLength={11}
                    defaultValue={editingContact.accbsUser_phone || ""}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, "");
                      setEditingContact((prev) => ({
                        ...prev,
                        accbsUser_phone: value,
                      }));
                    }}
                  />
                </div>
              )}
            </form>

            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setEditingContact(null)}
              >
                Cancelar
              </button>
              <button
                className="save-btn"
                onClick={() => {
                  handleEdit();
                  setEditingContact(null);
                }}
              >
                Guardar cambios
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para deshabilitar contacto */}
      {deleteContact && (
        <div className="modal-overlay">
          <div className="modal-content add-contact-modal">
            <button
              className="close-btn"
              onClick={() => setDeleteContact(null)}
            >
              <FaTimes />
            </button>
            <h3>Deshabilitar contacto</h3>
            <p>¿Estás seguro de que deseas deshabilitar este contacto?</p>
            <div className="modal-actions">
              <button
                className="cancel-btn"
                onClick={() => setDeleteContact(null)}
              >
                Cancelar
              </button>
              <button className="delete-btn" onClick={handleDelete}>
                Deshabilitar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal para agregar contacto */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content add-contact-modal">
            <button className="close-btn" onClick={() => closeModal()}>
              <FaTimes />
            </button>
            <h3>Agregar contacto</h3>

            <form>
              <div className="form-group">
                <label>País</label>
                <select
                  name="country"
                  value={accbsUser_country}
                  onChange={(e) => {
                    setAccbsUser_country(e.target.value);
                    setTransferType("");
                    setAccbsUser_number("");
                    setAccbsUser_owner("");
                    setAccbsUser_bank("");
                    setAccbsUser_dni("");
                    setAccbsUser_phone("");
                  }}
                >
                  <option value="">Seleccionar país</option>
                  {countries.map((c) => (
                    <option key={c}>{c}</option>
                  ))}
                </select>
              </div>

              {accbsUser_country && (
                <div className="form-group">
                  <div className="form-group">
                    <label>Tipo de transferencia</label>
                    <select
                      name="transferType"
                      value={transferType}
                      onChange={handleTransferTypeChange}
                    >
                      <option value="">Seleccionar tipo</option>
                      <option value="Cuenta Bancaria">Cuenta Bancaria</option>
                      {accbsUser_country === "Venezuela" && (
                        <option value="Pago Móvil">Pago Móvil</option>
                      )}
                      {accbsUser_country === "Estados Unidos" && (
                        <option value="Zelle">Zelle</option>
                      )}
                    </select>
                  </div>

                  {transferType === "Zelle" && (
                    <div className="form-group">
                      <label>Correo Electrónico</label>
                      <input
                        type="email"
                        name="account"
                        value={accbsUser_number}
                        onChange={(e) => {
                          setAccbsUser_number(e.target.value);
                        }}
                        placeholder="remesa@example.com"
                      />
                    </div>
                  )}

                  {transferType === "Cuenta Bancaria" && (
                    <div className="form-group">
                      <label>Número de Cuenta</label>
                      <input
                        type="text"
                        name="account"
                        value={accbsUser_number}
                        maxLength={
                          accbsUser_country === "Venezuela" ? 20 : undefined
                        }
                        pattern={
                          accbsUser_country === "Venezuela"
                            ? "\\d{20}"
                            : undefined
                        }
                        inputMode="numeric"
                        onChange={(e) => {
                          let value = e.target.value.replace(/\D/g, "");
                          if (
                            accbsUser_country === "Venezuela" &&
                            value.length > 20
                          ) {
                            value = value.slice(0, 20);
                          }
                          setAccbsUser_number(value);
                        }}
                        placeholder="Ej: 01021234567890123456"
                      />
                      {accbsUser_country === "Venezuela" &&
                        accbsUser_number.length > 0 &&
                        accbsUser_number.length !== 20 && (
                          <span style={{ color: "red", fontSize: "0.9em" }}>
                            El número de cuenta debe tener exactamente 20
                            dígitos.
                          </span>
                        )}
                    </div>
                  )}

                  {transferType === "Pago Móvil" && (
                    <div className="form-group" style={{ gap: 8 }}>
                      <label style={{ minWidth: 120 }}>
                        Número de Teléfono
                      </label>
                      <div style={{ display: "flex", flex: 1, gap: 4 }}>
                        <Input
                          type="select"
                          name="phonePrefix"
                          id="phonePrefix"
                          value={phonePrefix}
                          style={{ width: 90 }}
                          onChange={(e) => setPhonePrefix(e.target.value)}
                        >
                          <option value="0414">0414</option>
                          <option value="0424">0424</option>
                          <option value="0412">0412</option>
                          <option value="0422">0422</option>
                          <option value="0416">0416</option>
                          <option value="0426">0426</option>
                        </Input>
                        <input
                          type="text"
                          name="phone"
                          value={accbsUser_phone}
                          style={{ flex: 1 }}
                          maxLength={7}
                          inputMode="numeric"
                          onChange={(e) => {
                            let value = e.target.value.replace(/\D/g, "");
                            if (value.length > 7) value = value.slice(0, 7);
                            setAccbsUser_phone(value);
                          }}
                          placeholder="1234567"
                        />
                      </div>
                    </div>
                  )}

                  {transferType !== "Zelle" && (
                    <div className="form-group">
                      <label>Banco</label>
                      <Input
                        type="select"
                        name="bank"
                        value={accbsUser_bank}
                        onChange={(e) => setAccbsUser_bank(e.target.value)}
                      >
                        <option value="">Seleccione un banco</option>
                        {banksByCountry[accbsUser_country]?.map((bank) => (
                          <option key={bank} value={bank}>
                            {bank}
                          </option>
                        ))}
                      </Input>
                    </div>
                  )}

                  {accbsUser_country !== "Venezuela" &&
                    accbsUser_country !== "Estados Unidos" && (
                      <div className="form-group">
                        <label>Tipo de transferencia</label>
                        <select
                          name="accountType"
                          value={accountType}
                          onChange={(e) => setAccountType(e.target.value)}
                        >
                          <option value="">Seleccionar tipo</option>
                          <option value="Ahorro">Cuenta Ahorro</option>
                          <option value="Corriente">Cuenta Corriente</option>
                        </select>
                      </div>
                    )}

                  <div className="form-group">
                    <label>Nombre y Apellido</label>
                    <input
                      type="text"
                      name="name"
                      value={accbsUser_owner}
                      onChange={(e) => setAccbsUser_owner(e.target.value)}
                    />
                  </div>

                  {transferType !== "Zelle" && (
                    <div className="form-group" style={{ gap: 8 }}>
                      <label style={{ minWidth: 120 }}>Identificación</label>
                      {accbsUser_country === "Venezuela" ? (
                        <div style={{ display: "flex", flex: 1, gap: 4 }}>
                          <Input
                            type="select"
                            name="dniPrefix"
                            id="dniPrefix"
                            value={dniPrefix}
                            style={{ width: 90 }}
                            onChange={(e) => setDniPrefix(e.target.value)}
                          >
                            <option value="">Seleccione</option>
                            <option value="V-">V-</option>
                            <option value="E-">E-</option>
                            <option value="J-">J-</option>
                            <option value="G-">G-</option>
                            <option value="P-">P-</option>
                            <option value="C-">C-</option>
                          </Input>
                          <input
                            type="text"
                            style={{ flex: 1 }}
                            name="identification"
                            value={accbsUser_dni}
                            onChange={(e) => setAccbsUser_dni(e.target.value)}
                            placeholder="12345678"
                          />
                        </div>
                      ) : (
                        <input
                          type="text"
                          style={{ flex: 1 }}
                          name="identification"
                          value={accbsUser_dni}
                          onChange={(e) => setAccbsUser_dni(e.target.value)}
                          placeholder="Identificación"
                        />
                      )}
                    </div>
                  )}
                </div>
              )}
            </form>

            <div className="modal-actions">
              <button onClick={() => closeModal()}>Cancelar</button>
              <button onClick={handleSaveAcc}>Guardar</button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de estado de operación */}
      {operationStatus && (
        <div className="modal-overlay">
          <div className="modal-content status-modal">
            {operationStatus === "loading" && (
              <>
                <div className="spinner"></div>
                <p className="status-text">Procesando...</p>
              </>
            )}

            {operationStatus === "success" && (
              <>
                <div className="status-icon success">
                  <svg viewBox="0 0 52 52">
                    <path
                      d="M14 27 l10 10 l15 -20"
                      fill="none"
                      stroke="#2a9d8f"
                      strokeWidth="5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <p className="status-text">¡Operación exitosa!</p>
              </>
            )}

            {operationStatus === "error" && (
              <>
                <div className="status-icon error">
                  <svg viewBox="0 0 52 52">
                    <line
                      x1="16"
                      y1="16"
                      x2="36"
                      y2="36"
                      stroke="#d94343"
                      strokeWidth="5"
                      strokeLinecap="round"
                    />
                    <line
                      x1="36"
                      y1="16"
                      x2="16"
                      y2="36"
                      stroke="#d94343"
                      strokeWidth="5"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <p className="status-text">Ha ocurrido un error</p>
              </>
            )}

            <div className="status-actions">
              {operationStatus !== "loading" && (
                <button
                  className="close-btn"
                  onClick={() => setOperationStatus(null)}
                >
                  Cerrar
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <UserNavbar logOut={user?.use_email} />
    </div>
  );
}

export { Directory };
